import getHyliaApiClient from 'clients/hylia-api';
import { RewardListDto } from '@peartherapeutics/hylia-api-client';

export const getPatientRewards = async (
  patientId: string,
  accessRightId: string,
): Promise<RewardListDto> => {
  const api = await getHyliaApiClient();
  const rewardList = await api.getPatientRewards(patientId, accessRightId);
  return rewardList.data;
};

export const rewardsService = {
  getPatientRewards,
};
